<template>
    <div>
        <!-- <top-carousel style="width: 100%;"></top-carousel> -->
         <div>
            <img src="../../../../assets//img//common/banner_news.png" alt="bannner图" style="width: 100%;"/>
         </div>
        <div class="article container abttyou">
            <div class="weizhi">
                <h2>
                    <i class="product-title">
                        {{ titleInfo.zh }}&nbsp;&nbsp;&nbsp;&nbsp;{{
                            titleInfo.en
                        }}
                    </i>
                    <span
                        ><a @click="jumpPage">{{ titleInfo.zh }}</a> &gt;
                        {{ detailInfo.F_Title }}</span
                    >
                </h2>
            </div>
            <div class="abounei">
                <h1>{{ detailInfo.F_Title }}</h1>
                <div
                    v-html="content"
                    class="edit-article-content ql-editor"
                ></div>
                <div v-if="detailInfo.F_Keywords">
                    关键字: &nbsp;&nbsp;&nbsp;<span
                        class="article-tag mr20"
                        v-for="item in toArray(detailInfo.F_Keywords)"
                        :key="item"
                        >{{ item }}</span
                    >
                </div>
                <div class="clearfix">
                    <div class="prev">
                        上一个：
                        <a
                            @click="changeIndex(detailInfo.F_LastId)"
                            v-if="detailInfo.F_LastTitle"
                            >{{ detailInfo.F_LastTitle }}</a
                        >
                        <span v-else>无</span>
                    </div>
                    <div class="next">
                        下一个：
                        <a
                            @click="changeIndex(detailInfo.F_NextId)"
                            v-if="detailInfo.F_NextTitle"
                            >{{ detailInfo.F_NextTitle }}</a
                        >
                        <span v-else>无</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { getDetail2 } from '../../../../service/secondHttp'
export default {
    data() {
        return {
            detailInfo: {},
            keyWords: [],
            titleInfo: {
                zh: '新闻中心',
                en: 'NEWS CENTER',
            },
            id: this.$route.params.id,
            type: this.$route.params.type,
        }
    },
    methods: {
        getArticleInfo(id) {
            if (id) {
                getDetail2('Article', { keyvalue: id }, (data) => {
                    this.detailInfo = data
                })
            }
        },
        jumpPage() {
            this.$router.push('/newsList/' + this.type)
        },
        toArray(str) {
            if (str) {
                return str.split(',')
            } else {
                return []
            }
        },
        changeIndex(id) {
            this.getArticleInfo(id)
        },
    },
    mounted() {
        if (this.type == 14) {
            this.titleInfo = {
                zh: '企业动态',
                en: 'COMPANY NEWS',
            }
        } else if (this.type == 15) {
            this.titleInfo = {
                zh: '行业资讯',
                en: 'INDUSTRY INFORMATION',
            }
        }
        this.getArticleInfo(this.id)
    },
    computed: {
        content() {
            return unescape(this.detailInfo.F_Content || '')
        },
    },
}
</script>
<style lang="less">
@import '../../../../assets/css/article.less';
.article {
    font-size: 16px;
    font-family: 'Microsoft YaHei';
    background: #FFF;
    border-radius: 5px;
}
.article-title {
    font-size: 28px;
    word-wrap: break-word;
    font-weight: 600;
    margin: 0;
    word-break: break-all;
    margin-bottom: 15px;
    margin-top: -10px;
    color: #222;
    .el-tag {
        background-color: #fff;
        color: #0594fa;
        border: 1px solid #0594fa;
        font-weight: 400;
        position: relative;
        top: -2px;
    }
}
.article-tag {
    margin-right: 8px;
    padding: 0 8px;
    height: 24px;
    line-height: 22px;
    border-radius: 4px;
    display: inline-block;
    color: #0594fa;
    border: 1px solid #0594fa;
    font-size: 14px;
}
.edit-article-content {
    background: none;
}
.ql-align-center {
    text-indent: 0 !important;
}
strong {
    color: #4f4f4f;
}

.abttyou .abounei {
    padding:50px;
    h2 {
        text-align: left;
    }
}

</style>
